import { useEffect, useState } from 'react'
import * as charterApi from '../api/charter'
import type { MyPrepStatus } from '../redux/types/charterTypes'

const POLL_MS = 5000

/**
 * The student's prep progress and team state, re-checked while `enabled`.
 *
 * Nothing pushes to a student who has no team yet: the professor opening the
 * round or placing them only shows up on the next poll.
 */
export function useMyPrepStatus(roomId: string, enabled = true) {
  const [status, setStatus] = useState<MyPrepStatus | null>(null)

  useEffect(() => {
    if (!roomId || !enabled) return
    let cancelled = false
    const load = async () => {
      try {
        const res = await charterApi.getMyPrepStatus(roomId)
        if (!cancelled) setStatus(res.data)
      } catch {
        /* not a member yet, or a transient error — try again next tick */
      }
    }
    load()
    const id = setInterval(load, POLL_MS)
    return () => {
      cancelled = true
      clearInterval(id)
    }
  }, [roomId, enabled])

  return status
}
